import {makeStyles} from "@material-ui/core/styles";

const useStyles:any = makeStyles((theme) => ({
   tabs_container: {
        width:'100%',
        minWidth: '1000px',
    },
}))
export {useStyles}
